export const searchThemesFromTrendsCharts = {
    yAxisUnitOfBusinessAmount: 'm USD',
    yAxisUnit: 'bn yen'
}
